import http from 'plugins/axios';

export default {
  getLogList() {
    return http.post({
      url: '/la/admin/st/log/monitor/search'
    });
  }
};
